import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { removeBtnFocusBorder } from "@waytek/Utilities/styleguide/btnIcon";
import { colorPalette, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

headerStyles.container = {
    ...headerStyles.container,

    gap: 0,

    css: css`
        border-top: solid 3px ${colorPalette.common.global.industrialTaupe};
        padding-top: 10px;
        margin-bottom: 30px;

        ${mediaQueriesBP.minMD} {
            padding-top: 12px;
        }

        @media print {
            margin: 0;
        }
    `,
};

headerStyles.infoGridItem = {
    ...headerStyles.infoGridItem,

    css: css`
        ${headerStyles.infoGridItem?.css}

        align-items: flex-start;

        @media print {
            clear: both;
        }
    `,
};

headerStyles.sharingStatus = {
    statusText: {
        size: 14,
        weight: "normal",
        lineHeight: 1.71,

        css: css`
            margin-top: 14px;

            ${mediaQueriesBP.minMD} {
                margin-left: 20px;
                margin-top: 0;
            }

            ${StyledButton} {
                ${removeBtnFocusBorder}

                position: relative;
                text-align: right;
                line-height: 0;
            }

            & > [class*="TooltipWrapper"] {
                ${StyledButton} {
                    margin-left: 5px;
                    top: 3px;
                }
            }

            ${IconWrapper} {
                color: ${colorPalette.common.global.guardianBlue};
                height: 16px;
            }

            @media print {
                margin-left: 20px;
            }
        `,
    },
};

headerStyles.descriptionGridItem = {
    ...headerStyles.descriptionGridItem,

    css: css`
        &&& {
            margin-top: 12px;
        }
    `,
};

headerStyles.lastUpdateText = {
    ...headerStyles.lastUpdateText,

    weight: "normal",

    css: css`
        font-size: 12px;
        line-height: normal;

        ${mediaQueriesBP.minMD} {
            font-size: 14px;
            line-height: 1.71;
        }
    `,
};

headerStyles.descriptionStyles = {
    ...headerStyles.descriptionStyles,

    heading: {
        weight: "bold",

        css: css`
            font-size: 12px;
            line-height: normal;

            ${mediaQueriesBP.minMD} {
                font-size: 14px;
                line-height: 1.71;
            }
        `,
    },

    text: {
        weight: "normal",

        css: css`
            font-size: 12px;
            line-height: normal;

            ${mediaQueriesBP.minMD} {
                font-size: 14px;
                line-height: 1.71;
            }
        `,
    },
};

headerStyles.totalText = {
    ...headerStyles.totalText,

    size: 14,
    weight: "bold",
    lineHeight: 1.71,

    css: css`
        padding: 0;
        margin-top: 12px;

        ${mediaQueriesBP.minMD} {
            margin-left: auto;
            margin-top: 0;
        }

        @media print {
            float: right;
            margin: 0;
        }
    `,
};

headerStyles.totalVatLabelText = {
    ...headerStyles.totalVatLabelText,

    css: css`
        ${headerStyles.totalVatLabelText?.css}

        margin-top: 8px;

        ${mediaQueriesBP.minMD} {
            margin-top: 0;
        }
    `,
};

headerStyles.totalWithoutVatText = {
    ...headerStyles.totalWithoutVatText,

    css: css`
        ${headerStyles.totalWithoutVatText?.css}

        margin-top: 8px;

        ${mediaQueriesBP.minMD} {
            margin-top: 0;
        }
    `,
};

headerStyles.totalWithoutVatLabelText = {
    ...headerStyles.totalWithoutVatLabelText,

    css: css`
        ${headerStyles.totalWithoutVatLabelText?.css}

        margin-top: 8px;

        ${mediaQueriesBP.minMD} {
            margin-top: 0;
        }
    `,
};
